import { merge } from 'lodash-es';

// Merges host-supplied configs over our defaults. supportedFieldTypes is handled separately
// (rather than left to lodash's deep merge) for two reasons:
//  1. lodash merge splices arrays element-by-element instead of replacing them wholesale, which
//     is not what we want for a list of supported field types.
//  2. lodash merge only skips `undefined` source values, not `null` - a `null`/non-array
//     hostConfigs.supportedFieldTypes would otherwise overwrite the default array with `null`.
// Excluding supportedFieldTypes from the initial merge() call (rather than only guarding the
// follow-up assignment with Array.isArray) ensures a null/undefined/non-array host value can
// never leak into mergedConfigs - the default is kept until a valid array is provided.
export const mergeHostConfigs = (defaultConfigs, hostConfigs = {}) => {
  const { supportedFieldTypes, ...restHostConfigs } = hostConfigs;
  const mergedConfigs = merge({}, defaultConfigs, restHostConfigs);
  if (Array.isArray(supportedFieldTypes)) {
    mergedConfigs.supportedFieldTypes = supportedFieldTypes;
  }
  return mergedConfigs;
};
